import React, {ReactNode} from "react";
import RppColors from "../../RppColors";
import {Tooltip} from "@mui/material";
import IconLink from "@mui/icons-material/Link";
import IconLinkOff from "@mui/icons-material/LinkOff";


class DeviceLink extends React.Component<{
    device: {
        online: boolean;
    } | undefined;
    onlineExpressionI18N: string;
    style?: React.CSSProperties;
}, {}> {

    public render(): ReactNode {
        if (this.props.device) {
            return (
                <Tooltip title={this.props.onlineExpressionI18N}>
                    <div>
                        {!this.props.device.online && (
                            <IconLinkOff style={{ fontSize: "1em", ...this.props.style, color: RppColors.deviceOffline()}}/>
                        )}
                        {this.props.device.online && (
                            <IconLink style={{ fontSize: "1em", ...this.props.style, color: RppColors.deviceOnline()}}/>
                        )}
                    </div>
                </Tooltip>
            );
        }
        return (<IconLinkOff style={{...this.props.style, color: RppColors.deviceOffline()}}/>);
    }

}


export default DeviceLink;
